function updateErdProductUi(sectionId, variant) {
  const productInfo = document.getElementById(`MainProduct-${sectionId}`);
  if (!productInfo || !productInfo.classList.contains('product-info--main')) return;

  const caption = document.querySelector(`[data-variant-caption][data-section="${sectionId}"]`);
  if (caption && variant) {
    caption.textContent = variant.title;
  }

  const productForm = document.getElementById(`product-form-${sectionId}`);
  const addButton = productForm?.querySelector('[name="add"]');
  const addButtonText = addButton?.querySelector('span');
  if (!addButton || !addButtonText) return;

  if (addButton.hasAttribute('disabled')) {
    addButtonText.textContent = 'SOLD OUT';
    return;
  }

  const priceEl = document.getElementById(`price-${sectionId}`);
  const priceText =
    priceEl?.querySelector('.price-item--sale, .price-item--regular')?.textContent?.trim() ||
    priceEl?.querySelector('.price__regular .price-item--last')?.textContent?.trim();

  addButtonText.textContent = priceText ? `ADD TO CART — ${priceText}` : 'ADD TO CART';
}

function initErdProductUi() {
  document.querySelectorAll('product-info.product-info--main').forEach((productInfo) => {
    const sectionId = productInfo.dataset.section;
    if (!sectionId) return;

    const variantData = productInfo.querySelector('[data-selected-variant]');
    if (variantData) {
      try {
        updateErdProductUi(sectionId, JSON.parse(variantData.textContent));
      } catch (error) {
        updateErdProductUi(sectionId);
      }
    } else {
      updateErdProductUi(sectionId);
    }
  });
}

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    updateErdProductUi(event.data.sectionId, event.data.variant);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initErdProductUi();
  if (document.body.classList.contains('product-page')) {
    document.body.classList.add('product-page--ready');
  }
});
